import ActionTypes from '@ziynx/action-types';
import { getActionGroup } from '@ziynx/components/utilities';

const initialState = {};

type statementItemAction = {
  type?: string,
  id?: string,
};

export default function reduceStatementItems(
  state = initialState,
  action: statementItemAction,
) {
  if (!action.type) {
    return state;
  }

  const actionGroup = getActionGroup(action?.type);

  const statementItem = state[action?.id] ?? {};

  switch (action.type) {
  case ActionTypes.statementItem.getQuestion.START:
  case ActionTypes.statementItem.postQuestion.START:
  case ActionTypes.statementItem.getQuestionResponses.START:
    return {
      ...state,
      [action?.id ?? actionGroup]: {
        ...statementItem,
        fetching: action?.fetching ?? true,
        error: null,
        success: false,
        paginating: action?.paginating ?? false,
        paginatedSuccess: false,
      },
    };

  case ActionTypes.statementItem.patchQuestion.START:
    return {
      ...state,
      [action?.id]: {
        ...statementItem,
        fetching: true,
        success: false,
        error: null,
        patching: true,
        patchSuccess: false,
      },
    };

  /* When a response is viewed, this helps reduce number of dispatches.
  Regardless of success or error. */
  case ActionTypes.trackingAction.viewedResponse.START:
    return {
      ...state,
      [action?.statementId]: {
        ...state?.[action?.statementId],
        viewership: {
          ...state?.[action?.statementId]?.viewership,
          [action?.videoViewed]: true,
        },
      },
    };

  case ActionTypes.statementItem.postQuestion.SUCCESS:
    return {
      ...state,
      ...{
        [actionGroup]: {
          ...statementItem,
          ...(action?.response ?? {}),
          fetching: false,
          success: true,
          error: null,
        },
      },
    };
  case ActionTypes.statementItem.getQuestion.SUCCESS:
  case ActionTypes.statementItem.getQuestionResponses.SUCCESS:
    return {
      ...state,
      [action?.id]: {
        ...statementItem,
        ...(action?.response ?? {}),
        fetching: false,
        paginating: false,
        error: null,
        success: !action?.isPaginating,
        paginatedSuccess: action?.isPaginating,
      },
    };

  case ActionTypes.statementItem.patchQuestion.SUCCESS:
    return {
      ...state,
      [action?.id]: {
        ...statementItem,
        ...(action?.response ?? {}),
        fetching: false,
        success: true,
        error: null,
        patching: false,
        patchSuccess: true,
      },
    };
  case ActionTypes.statementItem.postQuestion.ERROR:
  case ActionTypes.statementItem.getQuestion.ERROR:
  case ActionTypes.statementItem.patchQuestion.ERROR:
    return {
      ...state,
      ...{
        [action?.id]: {
          ...statementItem,
          fetching: false,
          success: false,
          error: action?.error,
        },
      },
    };
  case ActionTypes.statementItem.clear:
    return {
      ...{
        [action?.id]: {
          ...(state?.POST_QUESTION_API ?? statementItem),
          fetching: false,
          success: false,
          patchSuccess: false,
          paginating: false,
          paginatedSuccess: false,
          error: null,
        },
      },
    };

    // no default
  }
  return state;
}
